var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundWave1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bgWave1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "3840px",
    height: "5539px",
    viewBox: "0 0 3840 5538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 2322.816406 5421.707031 C 3769.464844 5689.644531 4496.136719 5380.382812 4776.136719 5265.742188 L 4574.800781 -2273.808594 L -370.519531 -2372.449219 C -637.628906 114.957031 -1025.984375 5089.785156 -442.519531 5089.785156 C 286.816406 5089.785156 725.734375 5125.910156 2322.816406 5421.707031 Z M 2322.816406 5421.707031 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWave1);
export default __webpack_public_path__ + "static/media/backgroundWave1.8c83f88f504413de17f8d3e19e135b80.svg";
export { ForwardRef as ReactComponent };